import style from '../css/Report.module.css';
import React from 'react';

function Loader() {
  return (
    <div className={style.customLoaderOverlay}>
      <div className={style.customLoaderSpinner}></div>
    </div>
  );
}

export default Loader;